import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ZacksManifestoButton = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full bg-[#0a0a0a] py-6 text-center">
      <div className="relative group z-20 mx-auto w-fit max-w-[calc(100vw-2rem)] px-4">
        <div className="home-cta-founder-glow absolute -inset-1 bg-gradient-to-r from-[#00ffc8] via-[#20b2aa] to-[#00ffc8] rounded-full blur opacity-30 group-hover:opacity-60 transition duration-500 group-hover:duration-200 pointer-events-none"></div>
        <Button
          onClick={() => navigate('/zacks-manifesto')}
          className="home-cta-founder relative h-11 w-auto bg-[#050b14] px-8 text-[#00ffc8] border border-[#00ffc8]/50 shadow-[0_0_15px_rgba(0,255,200,0.4)] hover:shadow-[0_0_25px_rgba(0,255,200,0.6)] font-bold text-xs sm:h-12 sm:px-10 sm:text-sm rounded-full flex items-center justify-center gap-3 transition-all uppercase group glow-phantom"
        >
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#00ffc8]/30 bg-[#00ffc8]/20 transition-colors group-hover:bg-[#00ffc8]/30">
            <User className="h-4 w-4 text-white" />
          </div>
          <span className="text-center leading-tight tracking-wider text-white">
            Meet the Founder
          </span>
        </Button>
      </div>
    </div>
  );
};

export default ZacksManifestoButton;
